import { Injectable, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutService } from 'tr-lib';
@Injectable({
  providedIn: 'root'
})
export class ThemeInfoPopupService {

  private readonly dialogMaxWidth = '630px';
  private readonly dialogMobileMaxWidth = '100vw';
  private readonly dialogPanelClass = 'tr-modal-default';

  constructor(
    private dialog: MatDialog,
    private layoutService: LayoutService
  ) {}

  openOnce(
    storageKey: string,
    component: Type<unknown>,
    customConfig: object = {}
  ): void {

    const popupClosed = localStorage.getItem(storageKey);

    if (popupClosed === 'true') {
      return;
    }

    this.dialog.open(component, {
      maxWidth: this.layoutService.isMobile
        ? this.dialogMobileMaxWidth
        : this.dialogMaxWidth,

      panelClass: this.dialogPanelClass,

      autoFocus: false,

      disableClose: true,

      ...customConfig
    })
    .afterClosed()
    .subscribe(() => {
      localStorage.setItem(storageKey, 'true');
    });
  }
}